"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentHistory = void 0;
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _DocumentItem = require("../DocumentItem");
var _DocumentStyledComponents = require("./DocumentStyledComponents");
var _jsxRuntime = require("react/jsx-runtime");
const renderDocumentItem = (documentProps, key) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentItem.DocumentItem, {
  ...documentProps
}, key);
const DocumentHistory = props => {
  const {
    temporaryDocument,
    historyExpanded,
    documentIds,
    documentTypeId,
    deleteConfirmationRequired,
    histroyDocumentsInfoData,
    handleToggleClick,
    documentPending,
    mapToDocumentItemProps,
    removeDocument
  } = props;
  const getInfoByType = (typeId, includeTemporary) => histroyDocumentsInfoData?.filter(info => {
    const isTemporary = includeTemporary ?? false;
    return info.documentTypeId === typeId && (!info.isTemporary || isTemporary);
  }).sort((a, b) => {
    if (a.createdDate.getTime() && b.createdDate.getTime()) {
      return a.createdDate.getTime() - b.createdDate.getTime();
    }
    return 0;
  });
  const getHistoryDocuments = () => {
    if (!documentIds?.length) {
      return [];
    }
    const documentItems = getInfoByType(documentTypeId, temporaryDocument)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- we need this condition
    ?.filter(document => documentIds.includes(document.documentId) && !documentPending(document)).map(document => mapToDocumentItemProps(document, false, true, deleteConfirmationRequired, removeDocument));
    return documentItems;
  };
  const renderHistory = () => {
    const documents = getHistoryDocuments();
    //  eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not alway truthy we need this condition
    const existingDocuments = documents && documents.length > 0;
    if (!existingDocuments) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentStyledComponents.StyledDivHistory, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledDivExpander, {
        style: {
          display: historyExpanded ? 'block' : 'none'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledList, {
          children: documents.map(renderDocumentItem)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DocumentStyledComponents.StyledDivBoxExpandHistory, {
        onClick: () => handleToggleClick(),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.history,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.hide
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledExpanedIcon, {
          style: {
            transform: historyExpanded ? 'rotate(180deg)' : 'none'
          }
        })]
      })]
    });
  };
  const documentsHistory = renderHistory();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentStyledComponents.StyledDivHistory, {
    children: documentsHistory
  });
};
exports.DocumentHistory = DocumentHistory;